var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinancial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.720703,
    y: 0.534668,
    width: 17.5581,
    height: 17.907,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1491_6457",
    transform: "translate(0 0.00974025) scale(0.01 0.00980519)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1491_6457",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAEl0lEQVR4nO3cz2sdVRjG8eeYHxVii60u1LowUl0oWhcW1ArVhYgGa1Gj4k8oEjdi9131Xwi6EV20gkIW2ihW6SKiqK3tQtxUCy6CTa0tLtRFtLWSr4u5F2+Sc5OZm5k57828H+jmMufMe98nuXdy5kwl59w6BuwCTrT+7UpdT6MBLwOX+N9l4NXUdTUOEIADwAJxk0BIXWcjAMPAu12C6DQFXJm63nUN2Ax8niOMtq+Ba1PXvS4Bo8APBcJo+wm4JXX96wqwAzjfQxht54EdOc81BszlmHMOGKv6vZsD7AHm1xBG2zywJ8f58oTRdqaOHpgB7AP+LSGMtgXgwCrnLKSuXiQFDJBdulZlEhjocu6/i0xUd29qB4wA01WksMRnwMbI+e8BLuSdJEWPagNcB5ysKICY74GtkTpuBk7nmSBFn2oB3AbMVtj8bs4C2yP1bAG+XG1wil5VDtgJ/FZx41fyO/BgpK4NwHsrDUzRr0oBT1Pwi7Qil4CXIvW1182iUvSsMmSXtd0WCFNYIGv+soVJYC/wz9IBKfpWOmAQeKveXhdyCBiO1P0Q8GfngSn6VypgI9klp3UzwNWR+u8AzrQPStHD0gBbyS41+8Up4KbI+7gB+A76OBBgO8XWiaz4Fbg78n6uAo6U3ada7qoBuyW9L2mkjvNVYF7ScyGEjztfBIZCCJfLPNEVZU4WA0xI+kD9G4aU1f4h8Hrni2WHUSlWuX7vY5NAZT/IlXxkkd3LPijpmSrmN2Ba0vMhhL/Knrj0QIBrJH0kaWfZcxtzUtLuEMKFMictNRBgm6RPJTXlHvaspLEQwo9lTVjaZyFwn6Tjak4YkjQq6RvggbImLCUQYFzSjKQmbrnZLOko8GIZk605EGCfpClJTd6UNizpEF0WJovoeTAwKOlNSb6XdrGDkiZ6/Rulp0DI7kVPSXqkl/ENMCPpqRDCH0UHFg6E7B70J5LuKjq2YU4puwL7ucigQt8hwJ2SvpWHkcftko4TWZhcSe5AgIclfSXpxoKFNdn1kr4AHss7IFcgwCvKPqY29VhYk41IOgy8lufgFQOhtUAo6W1JgyUU11QDkt7IszDZ9Usd2KDsEu7ZkotrusOSXui2MBkNpLVAOC3p/goLa7ITkh6PLUzGtrtsk3RE0q01FNZks5IeDSGc7nxx0ecZcK+kY/Iw6jAq6RjdHuUme3LoYuQO2VHAr67WCNjU6uVSF4k9iQX8Ejn4HWAoQf3rEjDU6ulSZ2MHdz4TsQDsT1BzIwD7WbyFdvldR+BJ4BzZ3qnxBHU2CjBO9ijEOeCJ9uu9LC727269BEIIhXpc+b4sV4wHYowHYowHYowHYowHYowHYowHYowHYowHYowHYkxtGxeKrukstdY1tNTnz8t/Q4zxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxQIzxJ6gq5k9Q9TkPxBgPxBgPxBgPxBgPxBgPxBgPxBgPxBgPxBgPxJheAln+n225buaKDuglkIleTtRAc8p65ZxzzjnnkvsPo7sO64a6PbEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancial);
export default __webpack_public_path__ + "static/media/financial.0faab2c4b5a1c8506ae7c5ae81ea4e24.svg";
export { ForwardRef as ReactComponent };